
import { getcustomizedBannerList } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  }
})
export default class extends Vue {
  // 耗材定制轮播图
  bannerList: any[] = []

  // 代打印轮播图
  customizedList: any[] = []

  created() {
    this.getBannerList();
  }

  async getBannerList() {
    const anchor = readCookie('anchor');
    const res: any = await getcustomizedBannerList({
      channel: 1,
      companyId: 1,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : ''
    });
    this.bannerList = res.data.data.InsteadBananList;
    this.customizedList = res.data.data.customizeBananList;
  }

  private goDetails(id: string, type: number) {
    this.$router.push(
      `/consumables-details?id=${id}&type=${type}&from=carousel`
    );
  }
}
